export class RfpCancellationStatusCodes {
  public static readonly Initiated = 'Initiated';
  public static readonly Accepted = 'Accepted';
  public static readonly Denied = 'Denied';
}
